module.exports = __webpack_public_path__ + "img/logo.5596da06.png";